const timestamp = {
    getUTC: times => {
        let targetTime = new Date(times);
        let year = targetTime.getUTCFullYear();
        let month = targetTime.getUTCMonth() + 1;
        let day = targetTime.getUTCDate();
        let hour = targetTime.getUTCHours();
        let minute = targetTime.getUTCMinutes();
        let second = targetTime.getUTCSeconds();

        if(month >= 1 && month <= 9 )
            month = '0' + month

        if(day >= 0 && day <= 9)
            day = '0' + day

        if(hour >= 0 && hour <= 9)
            hour = '0' + hour

        if(minute >= 0 && minute <= 9)
            minute = '0' + minute

        if(second >= 0 && second <= 9)
            second = '0' + second
        
        return `${[year, month, day].join('/')} ${[hour, minute, second].join(':')}`;
    },
    get: times => {
        let targetTime = new Date(times);
        let year = targetTime.getFullYear();
        let month = targetTime.getMonth() + 1;
        let day = targetTime.getDate();
        let hour = targetTime.getHours();
        let minute = targetTime.getMinutes();
        let second = targetTime.getSeconds();

        if(month >= 1 && month <= 9 )
            month = '0' + month

        if(day >= 0 && day <= 9)
            day = '0' + day

        if(hour >= 0 && hour <= 9)
            hour = '0' + hour

        if(minute >= 0 && minute <= 9)
            minute = '0' + minute

        if(second >= 0 && second <= 9)
            second = '0' + second
        
        return `${[year, month, day].join('/')} ${[hour, minute, second].join(':')}`;
    },
    getDates: times => {
        let targetTime = new Date(times);
        let year = targetTime.getFullYear();
        let month = targetTime.getMonth() + 1;
        let day = targetTime.getDate();

        if(month >= 1 && month <= 9 )
            month = '0' + month

        if(day >= 0 && day <= 9)
            day = '0' + day
        
        return `${[year, month, day].join('/')}`;
    },
    upperMonth: times => {
        let targetTime = new Date(times);
        let year = targetTime.getUTCFullYear();
        let month = targetTime.getUTCMonth();
        let day = targetTime.getUTCDate();

        if(month === 0) month = 12;

        if(month >= 1 && month <= 9 )
            month = '0' + month

        if(day >= 0 && day <= 9)
            day = '0' + day
        
        return `${[year, month, day].join('-')}`;
    },
    arrangeTime: (times, months) => {
        let year = times.getFullYear();
        let month = (times.getMonth() + 1);
        let day = times.getDate();
        
        if (months >= month) {
            const reduce = !parseInt(months / 12) ? 1 : parseInt(months / 12);

            year = year - reduce;
            month = (12 - (months - month));
        }
        else month -= months;
        
        return timestamp.checkTime(year, month, day);
    },
    checkTime: (year, month, day) => {
        const checkTime = new Date(year, (month - 1), day).getDate() === day;
        
        if (!checkTime) return timestamp.checkTime(year, month, (day - 1));
        else return new Date([year, month, day].join('/'));
    }
}

export default timestamp;